import type { AsyncDataRequestStatus } from '#app'

export const useIsLoading = (status: Ref<AsyncDataRequestStatus, AsyncDataRequestStatus>) => {
  const isLoading = computed(() => status.value === 'pending')

  return { isLoading }
}
